import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row, Card, Button, CardBody, CardTitle, Modal, ButtonToolbar } from 'reactstrap';
import Notification from 'rc-notification';
import * as XLSX from 'xlsx';
import SmallLoader from '../../../../shared/components/SmallLoader';
import ResizableDataTable from '../../../Tables/ResizableTable/components/ResizableReactTable';
import { getPOSDetailsNew, deleteAllPOSNew, handleLoader } from '../../../../redux/actions/POSActionNew';
import { tableHeaderDataForUploadPOSNew as tableHeaderData } from "../../helper";

export const setCurrencyFormat = value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

const POSDetailNew = ({ dispatch }) => {
  const { t } = useTranslation('common');
  const location = useLocation();
  const navigate = useNavigate();
  const [posdata, setData] = useState([]);
  const [setModel] = useState(false);
  const { posData, isLoading, salesChannelFilterData } = useSelector(
    ({ posReducerNew, marketPlaceReducer }) =>
    ({
        posData: posReducerNew.posData, 
        isLoading: posReducerNew.isLoading,
        salesChannelFilterData: marketPlaceReducer.salesChannel
    }),
  );
  
  // Excel export function using XLSX
  const exportToExcel = () => {
    if (!posdata || !posdata.length) {
      console.log('No data to export');
      return;
    }

    // Define the columns and their mapping (same as your ExcelColumn structure)
    const excelColumns = [
        { header: 'Retailer', key: 'retailer', altKey: 'companyName' },
        { header: 'Week Ending', key: 'weekEnding' },
        { header: 'Product Description', key: 'productDescription', altKey: 'description' },
        { header: 'UPC', key: 'upc' },
        { header: 'Door Count', key: 'doorCount' },
        { header: 'Total Sales ($)', key: 'totalSalesAmount', altKey: 'amount' },
        { header: 'Total Units', key: 'totalUnits', altKey: 'quantitySold' },
        { header: 'Store $', key: 'storeSalesAmount', altKey: 'storeAmount' },
        { header: 'Store Units', key: 'storeUnits' },
        { header: '.com $', key: 'dotcomSalesAmount', altKey: 'onlineAmount' },
        { header: '.com Units', key: 'dotcomUnits', altKey: 'onlineUnits' },
        { header: 'UPC (New)', key: 'upcNew', altKey: 'key' },
        { header: 'Updated Name', key: 'updatedName' },
        { header: 'Category', key: 'category' },
        { header: 'Grouped name', key: 'groupedName' },
        { header: 'Description (Trimmed)', key: 'descriptionTrimmed' },
        { header: 'Innovation', key: 'innovation' },
        { header: '$PSPW', key: 'pspwAmount', altKey: 'pspw' },
        { header: 'UPSPW', key: 'upspw' },
        { header: 'Month', key: 'month' },
        { header: 'Year', key: 'year' },
        { header: 'Month / Year', key: 'monthYear' },
        { header: 'Store Count Zero', key: 'storeCountZero' },
        { header: 'Calculated $PSPW', key: 'calculatedPspwAmount', altKey: 'calculatedPspw' },
        { header: 'Calculated UPSPW', key: 'calculatedUpspw' },
        { header: 'Retail Calendar Wk', key: 'retailCalendarWk', altKey: 'week' },
        { header: 'Location', key: 'location', altKey: 'location' },
    ];

    // Prepare data for export
    const worksheetData = posdata.map(row => {
      const exportRow = {};
      excelColumns.forEach(col => {
        const val = row[col.key] !== undefined && row[col.key] !== null ? row[col.key] : (col.altKey ? row[col.altKey] : '');
        exportRow[col.header] = val !== undefined && val !== null ? val : '';
      });
      return exportRow;
    });

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    
    // Set column widths for better formatting
    const columnWidths = excelColumns.map((col) => {
      // Set different widths based on content
      if (col.key === 'productDescription') return { wch: 30 };
      if (col.key === 'retailer') return { wch: 20 };
      return { wch: 15 };
    });
    worksheet['!cols'] = columnWidths;

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "POS_New");

    // Save file
    XLSX.writeFile(workbook, "POS_New.xlsx");
  };
  
  // implement PDF generator //
  const container = React.useRef(null)
  const exportToPDF = () => {
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
     const btnUploadExcel = document.getElementById('btnUploadExcel');
     const dvDownloadV = document.getElementById('dvDownload');
     btnUploadExcel.style.display = "none";  
     dvDownloadV.style.display = "none";   
    const element = container.current || document.body;
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: 5,
      fileName: `New Point of sales Report ${new Date().getFullYear()}`,
    })
    btnUploadExcel.style.display = "block"; 
    dvDownloadV.style.display = "flex"; 
  }

  useEffect(() => {
    const bodyData = [];    
    dispatch(getPOSDetailsNew());
  }, []);

  useEffect(() => {
    setData(posData && posData.modal && posData.modal.data || []);
  }, [posData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    if (salesChannelFilterData && salesChannelFilterData.length > 0) {
      if (
        posData?.modal?.data?.length > 0
      ) {
        setData(
            posData.modal.data.filter(
            x =>
              salesChannelFilterData?.length > 0 &&
              salesChannelFilterData?.find(y => (y?.value?.toString() || '')?.toLowerCase()
                === x[OptChennel]?.toLowerCase()),
          ),
        );
      }
    } else {
      setData(posData && posData.modal && posData.modal.data || []);
    }
  }, [posData, salesChannelFilterData])

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const toggleDeleteModal = () => {
    if (!isLoading) {
      setShowDeleteModal(prev => !prev);
    }
  };

  const handleConfirmDeleteAll = async () => {
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'Deleting all POS data, please wait...',
        duration: 5,
        style: { top: 120, fontWeight: 'bold' },
        maxCount: 10,
      });
    });
    const res = await dispatch(deleteAllPOSNew());
    setShowDeleteModal(false);
    if (res && res.success) {
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'All POS data deleted successfully!',
          duration: 5,
          style: { top: 120, fontWeight: 'bold' },
          maxCount: 10,
        });
      });
    } else {
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Failed to delete POS data. Please try again!',
          duration: 5,
          style: { top: 120, fontWeight: 'bold' },
          maxCount: 10,
        });
      });
    }
  };

  const uploadExcel = () => {
    navigate('/pos/upload/new');    
  }

  return (
    <Container>
      <Card className="pb-3">
        <CardBody className="dashboard__card-widget card-shadow p-3">
          <CardTitle className="bold-text text-center" tag="h3">
            New Point Of Sales
          </CardTitle>
          </CardBody>
      </Card>
      {/* <Row>
        <Col md={9}>
          <h3 className="page-title">{t('POS')}</h3>
         
        </Col>
      </Row>     */}
      <CardBody className="p-2">
     
      <Row className="product-table-wrap">  
      <Col md='1'>
      <Button id='btnUploadExcel' className="btn btn-sm btn-primary" style={{marginTop: 22, marginLeft: 15, 
            color: 'white'}} title='Upload excel' onClick={uploadExcel}>Upload</Button>
            </Col>   
                <Col md='2'>
                <button className="btn btn-sm btn-primary apply-date-button" 
                type="button" style={{marginTop: 22, marginLeft: 15}} title='Export to pdf' 
                disabled={isLoading} onClick={exportToPDF}
                >Export pdf</button></Col> 
        <Col md='9' className='text-right'>
        <div 
          id='dvDownload' 
          className="ExcelTable"
          style={{ 
            position: 'absolute', 
            right: '2.25rem', 
            top: '22px', 
            zIndex: 1, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'flex-end' 
          }}
        >
          <button
            id='btnDeleteAll'
            type="button"
            className="btn btn-sm btn-danger"
            onClick={toggleDeleteModal}
            disabled={isLoading || !posdata?.length}
            style={{ 
              margin: '0 10px 0 0',
              height: '32px',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: (!posdata?.length || isLoading) ? 'not-allowed' : 'pointer',
              opacity: (!posdata?.length || isLoading) ? 0.6 : 1,
              whiteSpace: 'nowrap'
            }}
            title="Delete all data"
          >
            Delete All
          </button>
          <button
            id='btnDownload'
            type="button"
            className="btn btn-sm btn-primary"
            onClick={exportToExcel}
            disabled={!posdata?.length}
            style={{ 
              margin: 0,
              height: '32px',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: !posdata?.length ? 'not-allowed' : 'pointer',
              opacity: !posdata?.length ? 0.6 : 1,
              whiteSpace: 'nowrap'
            }}
            title="Download Excel"
          >
            Download
          </button>
        </div> 
        
        </Col>
                
        </Row>  
        <div ref={container}>
        <Row>
        <Col md='12'>       
          
          
          {isLoading ? <div style={{ minHeight: '200px' }}
          className="row align-items-center justify-content-center">
          <SmallLoader loading={isLoading} />
          </div>
            :            
            <ResizableDataTable
              reactTableData={{tableHeaderData}}
              data={posdata}
            />}
         
        </Col>
        </Row>
        </div>
      </CardBody>
      <Modal
        isOpen={showDeleteModal}
        toggle={toggleDeleteModal}
        className="modal-dialog--danger delete-confirm-modal"
        centered
      >
        <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            aria-label="modal__close-btn"
            type="button"
            onClick={toggleDeleteModal}
          />
          <span className="lnr lnr-cross-circle modal__title-icon" />
          <h4 className="text-modal modal__title">Delete All Data</h4>
        </div>
        <div className="modal__body" style={{ textAlign: 'center', padding: '10px 15px' }}>
          Are you sure you want to delete all records from Wholesale POS New? This action cannot be undone.
        </div>
        <ButtonToolbar className="modal__footer" style={{ justifyContent: 'center', gap: '20px', marginTop: '20px' }}>
          <Button 
            className="modal_cancel" 
            onClick={toggleDeleteModal} 
            disabled={isLoading}
            style={{ marginRight: '15px' }}
          >
            Cancel
          </Button>
          <Button 
            color="danger" 
            onClick={handleConfirmDeleteAll} 
            disabled={isLoading}
          >
            {isLoading ? 'Deleting...' : 'Yes, Delete All'}
          </Button>
        </ButtonToolbar>
      </Modal>
    </Container>
  );
};

POSDetailNew.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect()(POSDetailNew);